// Impressão direta via QZ Tray — manda o cupom/DANFE já pronto (HTML ou
// PDF) direto pra fila de impressão do Windows, SEM abrir o diálogo
// "Imprimir" do navegador. Não é infraestrutura nova: reaproveita a MESMA
// conexão/certificado já usados pra abrir a gaveta (ver utils/gaveta.js) —
// só um uso a mais da mesma ligação com o QZ Tray.
//
// Opt-in e por computador: só age quando o operador já ligou "Impressão
// Direta" em Ctrl+F12 → Opções e escolheu uma impressora. Se estiver
// desligado, sem impressora configurada, ou o QZ Tray falhar por qualquer
// motivo (não instalado, não aberto, impressora desligada/offline), estas
// funções devolvem `false` — quem chamou cai de volta no window.print()
// de sempre, sem quebrar nada.
//
// IMPORTANTE: o formato exato do job 'pixel' (impressão via driver, pra
// HTML/PDF — diferente do 'raw' hex já usado na gaveta, que manda bytes
// crus direto pra impressora) segue a API pública do QZ Tray de memória;
// testar de verdade contra o QZ Tray instalado antes de confiar 100% em
// produção — mesma ressalva que já vale pro regime normal em icms.js.
import qz from 'qz-tray';
import { conectar, impressoraImpressaoSalva, impressaoDiretaAtiva } from './gaveta';

// winFallback (opcional): janela em branco já aberta como plano B (pro
// window.print() de sempre) — se a impressão direta der certo, ela é
// fechada sem nunca aparecer nada pro operador.
export async function tentarImprimirDiretoHtml(html, winFallback) {
  if (!impressaoDiretaAtiva()) return false;
  const nome = impressoraImpressaoSalva();
  if (!nome) return false;
  try {
    await conectar();
    const config = qz.configs.create(nome);
    await qz.print(config, [{ type: 'pixel', format: 'html', flavor: 'plain', data: html }]);
    try { winFallback?.close(); } catch (_) {}
    return true;
  } catch (err) {
    console.error('[Impressão direta] HTML falhou, caindo pro diálogo do navegador:', err);
    return false;
  }
}

export async function tentarImprimirDiretoPdf(base64, winFallback) {
  if (!impressaoDiretaAtiva()) return false;
  const nome = impressoraImpressaoSalva();
  if (!nome) return false;
  try {
    await conectar();
    const config = qz.configs.create(nome);
    await qz.print(config, [{ type: 'pixel', format: 'pdf', flavor: 'base64', data: base64 }]);
    try { winFallback?.close(); } catch (_) {}
    return true;
  } catch (err) {
    console.error('[Impressão direta] PDF falhou, caindo pro diálogo do navegador:', err);
    return false;
  }
}

// Blob (PDF vindo do backend) → base64, pra mandar pro QZ Tray.
export function blobParaBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
